<script setup lang="ts">
    import AcademyTrainingsCarouselClientContent from './AcademyTrainingsCarouselClientContent.vue';
    import AcademyTrainingsCarouselView from './AcademyTrainingsCarouselView.vue';
    import { useScopedAcademyTrainingsListing } from '~/composables/useAcademyTrainingsListing';
    import { AcademyTrainingsListingSortSlug } from '~/types/academy/trainings-listing-sort';
    import { ACADEMY_TRAININGS_CAROUSEL_MAX_ITEMS } from '~/utils/academy/constants';
    import { buildCarouselFixedFilters } from '~/utils/academy/trainings/carouselFilters';
    import type { AcademyTrainingsCarouselStoryblok } from '~storyblok-types/AcademyTrainingsCarouselStoryblok';

    const props = defineProps<{
        type: AcademyTrainingsCarouselStoryblok['type'];
        rootFolder?: string;
        headline?: string;
        noResultsMessage: string;
    }>();

    const { setRootFolder, setPageSize, setFixedFilters, items, prettyError, isInitialLoading, showNoResults, sort } =
        useScopedAcademyTrainingsListing();

    setRootFolder(() => props.rootFolder);
    setPageSize(ACADEMY_TRAININGS_CAROUSEL_MAX_ITEMS);
    setFixedFilters(() => buildCarouselFixedFilters(props.type));

    watch(
        () => props.type,
        (newType) => {
            if (newType === 'event') {
                sort.value = AcademyTrainingsListingSortSlug.EventDate;
            } else {
                sort.value = AcademyTrainingsListingSortSlug.Newest;
            }
        },
        { immediate: true }
    );
</script>

<template>
    <AcademyTrainingsCarouselView :headline="props.headline">
        <template
            v-if="$slots.teaser"
            #teaser
        >
            <slot name="teaser" />
        </template>

        <AcademyTrainingsCarouselClientContent
            :is-initial-loading="isInitialLoading"
            :pretty-error="prettyError"
            :items="items"
            :show-no-results="showNoResults"
            :no-results-message="props.noResultsMessage"
        />

        <template
            v-if="$slots.link"
            #link
        >
            <slot name="link" />
        </template>
    </AcademyTrainingsCarouselView>
</template>
